import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";

export class NonconformityProcedure extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'nonconformityProcedure'}
            title={'PROCEDURE P14.0 NONCONFORMITY AND CORRECTIVE ACTION'}
            exportTitle={'<h2>Procedure P14.0 Nonconformity and Corrective Action</h2>'}
            exportFileName={'nonconformity_procedure.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (NonconformityProcedure);
